export default __webpack_public_path__ + "static/media/edit_black.5e613960.svg";